import { useSyncExternalStore } from 'react';
import type { SoundLibraryWire } from '@inverse/protocol';
import { sounds } from '../../game/sound';

/** The library as the world last sent it, kept current. */
export function useSoundLibrary(): SoundLibraryWire {
  return useSyncExternalStore(sounds.watch, sounds.library);
}
